export { default } from './Collection';
export type { CollectionProps, CollectionClassKey, CollectionClasses } from './Collection.types';
